import Api from '../../../common/services/api';

export const NETWORK_RECEIVE_TEAMS = 'network/RECEIVE_TEAMS';

export default () => async (dispatch, getState) => {
  const { network: { selected } } = getState();

  if (!selected) return null;

  const networkId = selected;

  const { data: teams } = await Api.get(`/v2/networks/${networkId}/teams`);

  if (getState().network.selected !== networkId) return null;

  return dispatch({
    type: NETWORK_RECEIVE_TEAMS,
    teams,
  });
};
